import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { ConfigService } from '../utils/config.service';
import { Workflow } from '../../models/access-request/workflow.model';

@Injectable({ providedIn: 'root' })
export class AccessRequestService extends RestService<Workflow> {

  public constructor(configService: ConfigService, http: HttpClient) {
    super('/access-requests', http, configService);
  }

  public getAccessRequestStatus(data: { companyId: number }) {
    return this.makeRequest('get', '/access-requests/get-access-module-status', data);
  }
}
